import styled from 'styled-components';
import Alert from 'gatsby-theme-core/src/components/alert';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${Alert} {
    margin-bottom: 1rem;
    margin-top: unset;
  }
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    flex-direction: row;
    ${Alert} {
      margin-bottom: unset;
      margin-top: unset;
      order: 1;
    }
  }

`;

export default Wrapper;
